import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Text } from '@mantine/core';

type ActionOptionPropsType = {
  label: string;
};

export const ActionOption: React.FC<ActionOptionPropsType> = ({ label }) => {
  return (
    <Group c="blue">
      <FontAwesomeIcon icon={faPlus} />
      <Text>{label}</Text>
    </Group>
  );
};
